export var toErrors = function toErrors(errorMessages) {
  return errorMessages.map(function (e) {
    return {
      text: e,
      type: 'error'
    };
  });
};